/* Locations */
export const LIST_LOCATIONS = "LIST_LOCATIONS"
export const LIST_LOCATIONS_SUCCESS = "LIST_LOCATIONS_SUCCESS"
export const LIST_LOCATIONS_ERROR = "LIST_LOCATIONS_ERROR"
